import { BigNumber } from "bignumber.js";
import { assetColors, assetTypeClassNameMap } from "components/AssetColorMap";
import { PRODUCT_ASSIGN_UNIT } from "components/Portfolio/index";
import { useEffect, useState } from "react";
import { CSSTransition } from "react-transition-group";
import styled from "styled-components";
import {
  NotosansjpMediumBlue12px,
  NotosansjpMediumWhite12px,
  NotosansjpNormalCloudBurst12px
} from "../../styledMixins";

const FormDiv = styled.div`
  position: fixed;
  top: 0;
  right: ${props => `-${props.dialogWidth}px`}; /* 動的に計算された幅で画面外に配置 */
  width: ${props => `${props.dialogWidth}px`}; /* 動的に計算された幅 */
  height: 100%;
  background-color: #ffffff;
  z-index: 9999999999;
  overflow-y: auto;
  overflow-x: hidden;
  transition: transform 300ms;
  filter: drop-shadow(2px 2px 8px rgba(0, 0, 0, 0.5));

  &.ratio-editor-v3-modal-sidebar-enter-done {
    opacity: 1;
    transform: translateX(-${props => `${props.dialogWidth}px`}); /* 動的に計算された幅でスライドイン */
  }
`;

const FormHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: 25px;
  background-color: #ffffff;
  border-bottom: 2px solid #e5eced;
  height: 55px;
  font-size: 16px;
  font-weight: bold;
  color: #192e55;
`;


const FormContent = styled.div`
  padding: 20px 50px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FormFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 40px 50px 50px;
`;

const SaveButton = styled.button`
  width: 160px;
  height: 36px;
  ${NotosansjpMediumWhite12px}
  background-color: #2397CE;
  border: none;
  &:hover {
    background-color: #2b7eb0;
  }
  &:active {
    background-color: #192e55;
  }
  &.inactive {
    background-color: #9fa0a0;
    cursor: initial;
  }
`;

const CancelButton = styled.button`
  width: 160px;
  height: 36px;
  ${NotosansjpMediumBlue12px}
  background-color: #ffffff;
  border: 1px solid #dddcdb;
  &:hover {
    background-color: #e8eff2;
  }
  &:active {
    background-color: #192e55;
  }
`;

const AllFadeFrame = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  z-index: 9999999;
  background-color: #000;
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
`;

const CheckboxLabel = styled.label`
  ${NotosansjpNormalCloudBurst12px}
  cursor: pointer;
`;

const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ScrollableTableWrapper = styled.div`
  overflow-x: auto;
  overflow-y: visible;
  max-width: 100%;
  
  /* スクロールバーのスタイリング */
  &::-webkit-scrollbar {
    height: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

const ScrollableTableContent = styled.div`
  min-width: fit-content;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const TableHeader = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 5px;
  border-bottom: 1px solid #e5eced;
`;

const UpdatePortTargetLabel = styled.div`
  width: 385px;
  ${NotosansjpNormalCloudBurst12px}
  font-weight: bold;
  padding-top: 10px;
  text-align: right;
`;

const PortfolioHeader = styled.div`
  width: 120px;
  text-align: center;
  ${NotosansjpNormalCloudBurst12px}
  font-weight: bold;
  margin-left: 10px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Header = styled.div`
  min-width: 250px;
  width: 270px;
  text-align: right;
  margin-left: 125px;
  padding-right: 10px;
  ${NotosansjpNormalCloudBurst12px}
  font-weight: bold;
  flex-shrink: 0;
`;

const CheckBoxLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 4px;
  font-size: 10px;
`;


const PortfolioName = styled.div`
  ${NotosansjpNormalCloudBurst12px}
  font-weight: bold;
`;



const PortfolioCheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 10px;
`;

const PortfolioCheckboxLabel = styled.label`
  ${NotosansjpNormalCloudBurst12px}
  font-size: 10px;
  cursor: pointer;
`;

const BalanceLabel = styled.div`
  ${NotosansjpNormalCloudBurst12px}
  font-size: 11px;
  font-weight: bold;
  min-width: 250px;
  width: 270px;
  text-align: right;
  margin-left: 5px;
  padding-right: 10px;
`;

const BalanceInputWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #dde1e2;
  background-color: var(--white);
  height: 24px;
  width: 120px;
  margin-left: 10px;
  padding: 0 2px;

  &:focus-within {
    border: 1px solid #192e55;
    background-color: var(--twilight-blue);
  }

  &.disabled {
    background-color: #f5f5f5;
    border-color: #ccc;
  }

  &.error {
    border-color: #ff0000;
  }
`;

const BalanceInput = styled.input`
  ${NotosansjpNormalCloudBurst12px}
  font-size: 11px;
  text-align: right;
  border: none;
  outline: 0;
  background-color: transparent;
  padding: 2px 4px;
  height: 100%;
  flex-grow: 1;
  min-width: 0;

  &:disabled {
    background-color: #f5f5f5;
    color: #999;
  }
`;

const ProductRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  height: 25px;
`;

const AssetTypeDisplayContainer = styled.div`
  min-width: 115px;
  display: flex;
  align-items: center;
  height: 100%;
`;

const ProductNameSpan = styled.span`
  ${NotosansjpNormalCloudBurst12px}
  width: 270px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 5px;
`;

const AssetGroupDiv = styled.div`
  margin-bottom: 15px;
  border-left-width: 5px;
  border-left-style: solid;
  padding-left: 5px;
`;

const AssetTypeNameSpan = styled.span`
  ${NotosansjpNormalCloudBurst12px}
  font-weight: bold;
  width: 100px;
  display: inline-block;
`;

const RatioInput = styled.input`
  ${NotosansjpNormalCloudBurst12px}
  font-size: 11px;
  text-align: right;
  border: none;
  outline: 0;
  background-color: transparent;
  padding: 2px 4px;
  height: 100%;
  flex-grow: 1;
  min-width: 0;

  &:disabled {
    background-color: #f5f5f5;
    color: #999;
  }
`;

const RatioInputWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #dde1e2;
  background-color: var(--white);
  height: 24px;
  width: 120px;
  margin-left: 10px;
  padding: 0 2px;

  &:focus-within {
    border: 1px solid #192e55;
    background-color: var(--twilight-blue);
  }

  &.disabled {
    background-color: #f5f5f5;
    border-color: #ccc;
  }
`;

const PercentSpan = styled.span`
  ${NotosansjpNormalCloudBurst12px}
  font-size: 10px;
  margin-left: 2px;
  width: 15px;
  text-align: left;
  flex-shrink: 0;
`;

const TotalRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #e5eced;
`;

const TotalLabel = styled.span`
  ${NotosansjpNormalCloudBurst12px}
  font-weight: bold;
  width: 385px;
  text-align: right;
  padding-right: 10px;
`;

const TotalValue = styled.span`
  ${NotosansjpNormalCloudBurst12px}
  font-weight: bold;
  width: 120px;
  text-align: center;
  margin-left: 10px;
  color: ${(props) => {
    if (props.isDisabled) return "#999"; // チェックボックスがオフの場合はグレー
    return props.isValid ? "inherit" : "red"; // チェックボックスがオンの場合は従来通り
  }};
`;

const PortfolioRatioEditDialogV3 = (props) => {
  const {
    show,
    onClose,
    portfolios,
    amData,
    assetNames,
    onSubmit,
  } = props;

  const [portfolioTargetEnabled, setPortfolioTargetEnabled] = useState(new Map()); // ポートフォリオごとの対象設定
  const [portfolioBalances, setPortfolioBalances] = useState(new Map());
  const [portfolioRatios, setPortfolioRatios] = useState(new Map());
  const [originalPortfolioRatios, setOriginalPortfolioRatios] = useState(new Map()); // 100%調整前の真の初期値を保持
  const [adjustedPortfolioRatios, setAdjustedPortfolioRatios] = useState(new Map()); // 100%調整後の値を保持
  const [userModifiedPortfolios, setUserModifiedPortfolios] = useState(new Set()); // ユーザーが手動で変更したポートフォリオを記録
  const [groupedProducts, setGroupedProducts] = useState(new Map());
  const [portfolioNames, setPortfolioNames] = useState([]);
  const [dialogWidth, setDialogWidth] = useState(1200); // ダイアログの動的幅

  // フォーカス管理用のref（useRefを直接使用）
  const React = require('react');
  const inputRefs = React.useRef(new Map());

  // tabIndexを計算する関数（ポートフォリオ内縦方向遷移用）
  const calculateTabIndex = (productIndex, portfolioIndex, totalProducts) => {
    // 各ポートフォリオごとに連続したtabIndexを割り当て
    // ポート1残高(1000) → ポート1商品A(1001) → ポート1商品B(1002) → ポート1商品C(1003) → ポート2残高(1004) → ...
    const baseIndex = portfolioIndex * (totalProducts + 1); // +1は残高入力分
    return 1001 + baseIndex + productIndex; // 残高は1000 + baseIndex
  };

  // 残高入力のtabIndexを計算する関数
  const calculateBalanceTabIndex = (portfolioIndex, totalProducts) => {
    const baseIndex = portfolioIndex * (totalProducts + 1);
    return 1000 + baseIndex;
  };

  // フォーカス移動のキーハンドラー
  const handleKeyDown = (e) => {
    if (e.key === 'Tab') {
      // チェックボックスがONのポートフォリオのみを対象とする
      const enabledPortfolios = portfolioNames.filter(name => portfolioTargetEnabled.get(name));
      if (enabledPortfolios.length === 0) return;

      const totalProducts = Array.from(groupedProducts.values()).reduce((sum, productList) => sum + productList.length, 0);
      if (totalProducts === 0) return;

      const firstPortfolioIndex = portfolioNames.indexOf(enabledPortfolios[0]);
      const lastPortfolioIndex = portfolioNames.indexOf(enabledPortfolios[enabledPortfolios.length - 1]);
      
      const firstBalanceTabIndex = calculateBalanceTabIndex(firstPortfolioIndex, totalProducts);
      const lastProductTabIndex = calculateTabIndex(totalProducts - 1, lastPortfolioIndex, totalProducts);

      const activeElement = document.activeElement;
      const currentTabIndex = parseInt(activeElement.tabIndex);

      if (!e.shiftKey) {
        // Tab: 最後の商品から最初の残高へ
        if (currentTabIndex === lastProductTabIndex) {
          e.preventDefault();
          const firstBalanceInput = document.querySelector(`input[tabindex="${firstBalanceTabIndex}"]`);
          if (firstBalanceInput) {
            firstBalanceInput.focus();
          }
        }
      } else {
        // Shift+Tab: 最初の残高から最後の商品へ
        if (currentTabIndex === firstBalanceTabIndex) {
          e.preventDefault();
          const lastProductInput = document.querySelector(`input[tabindex="${lastProductTabIndex}"]`);
          if (lastProductInput) {
            lastProductInput.focus();
          }
        }
      }
    }
  };

  // 現行ポートフォリオ名を判定する関数
  const isCurrentPortfolio = (portfolioName) => {
    // 現行ポートフォリオは通常「現状」という文字が含まれるか、最初のポートフォリオ
    return portfolioName.includes('現状') || portfolioNames.indexOf(portfolioName) === 0;
  };

  // 100%調整機能
  const adjustRatiosTo100Percent = (ratiosMap) => {
    const ratioEntries = Array.from(ratiosMap.entries());
    if (ratioEntries.length === 0) return ratiosMap;
    
    // 商品に金額が入っているかチェック
    const hasNonZeroRatios = ratioEntries.some(([_, ratio]) => new BigNumber(ratio || 0).isGreaterThan(0));
    if (!hasNonZeroRatios) {
      // 金額が入っていない場合は調整をスキップ
      return ratiosMap;
    }
    
    // BigNumberを使用して合計を計算
    const total = ratioEntries.reduce((sum, [_, ratio]) => {
      return sum.plus(new BigNumber(ratio || 0));
    }, new BigNumber(0));
    
    const difference = new BigNumber(100).minus(total);
    
    // 誤差が存在する場合、0.1%以上の商品の中で最後のものに調整を適用
    if (difference.abs().isGreaterThan(new BigNumber('1e-9'))) {
      // 0.1%以上の商品を抽出
      const eligibleEntries = ratioEntries.filter(([_, ratio]) => new BigNumber(ratio || 0).isGreaterThanOrEqualTo(0.1));
      
      if (eligibleEntries.length > 0) {
        // 0.1%以上の商品の中で最後のものを選択
        const lastEligibleEntry = eligibleEntries[eligibleEntries.length - 1];
        const [lastProductId, lastRatio] = lastEligibleEntry;
        const adjustedRatio = new BigNumber(lastRatio || 0).plus(difference).toFixed(1);
        ratiosMap.set(lastProductId, adjustedRatio);
      } else {
        // 0.1%以上の商品がない場合は、従来通り最後の商品で調整
        const lastEntry = ratioEntries[ratioEntries.length - 1];
        const [lastProductId, lastRatio] = lastEntry;
        const adjustedRatio = new BigNumber(lastRatio || 0).plus(difference).toFixed(1);
        ratiosMap.set(lastProductId, adjustedRatio);
      }
    }
    
    return ratiosMap;
  };

  useEffect(() => {
    if (show && portfolios && amData) {
      console.log("V3Dialog useEffect - portfolios:", portfolios);
      console.log("V3Dialog useEffect - amData:", amData);
      
      // ダイアログが開かれた時にユーザー変更記録をリセット
      setUserModifiedPortfolios(new Set());
      
      const portfolioNamesList = Array.from(portfolios.keys());
      console.log("V3Dialog useEffect - portfolioNamesList:", portfolioNamesList);
      setPortfolioNames(portfolioNamesList);

      // 各ポートフォリオの合計金額を計算して残高として設定
      const initialBalances = new Map();
      portfolioNamesList.forEach(portfolioName => {
        const portfolio = portfolios.get(portfolioName);
        let portfolioTotalAmount = new BigNumber(0);
        
        if (portfolio && portfolio.assetProductAssigns) {
          for (const [assetType, productsMap] of portfolio.assetProductAssigns.entries()) {
            if (productsMap instanceof Map) {
              for (const [productName, assignInfo] of productsMap.entries()) {
                const productAmount = new BigNumber(assignInfo.assign || 0).multipliedBy(PRODUCT_ASSIGN_UNIT);
                portfolioTotalAmount = portfolioTotalAmount.plus(productAmount);
              }
            }
          }
        }
        
        const balanceValue = portfolioTotalAmount.dividedBy(PRODUCT_ASSIGN_UNIT).toString();
        console.log(`V3Dialog - ${portfolioName} balance:`, balanceValue);
        initialBalances.set(portfolioName, balanceValue);
      });

      setPortfolioBalances(initialBalances);

      // ポートフォリオごとの対象設定を初期化
      const initialTargetEnabled = new Map();
      portfolioNamesList.forEach(portfolioName => {
        const isCurrentPort = isCurrentPortfolio(portfolioName);
        const portfolio = portfolios.get(portfolioName);
        const isSelected = portfolio?.selected || false;
        const balance = parseFloat(initialBalances.get(portfolioName) || 0);
        
        let defaultEnabled;
        if (isCurrentPort) {
          // 現状ポートフォリオは常にオフ
          defaultEnabled = false;
        } else {
          // その他のポートフォリオは、ポート入力画面で選択されており、かつ残高が0より大きい場合のみオン
          defaultEnabled = isSelected && balance > 0;
        }
        initialTargetEnabled.set(portfolioName, defaultEnabled);
      });
      setPortfolioTargetEnabled(initialTargetEnabled);

      // 商品リストの構築（Portfolio/index.jsと同じソート順序を適用）
      const newGroupedProducts = new Map();
      const initialRatios = new Map();

      // 全ポートフォリオから商品リストを構築（最初のポートフォリオを基準）
      if (portfolioNamesList.length > 0) {
        const firstPortfolio = portfolios.get(portfolioNamesList[0]);
        if (firstPortfolio && firstPortfolio.assetProductAssigns) {
          for (const [assetType, productsMap] of firstPortfolio.assetProductAssigns.entries()) {
            const productListForAssetType = [];
            if (productsMap instanceof Map) {
              // Portfolio/index.jsと同じソートロジックを適用
              const productsIndex = amData.get(assetType)?.get("productsIndex") || {};
              const products = Array.from(productsMap.keys() || []).sort((a, b) => {
                const indexLevel = productsIndex[a] - productsIndex[b];
                if (indexLevel !== 0) return indexLevel;
                return a.localeCompare(b);
              });
              
              products.forEach(productName => {
                const assignInfo = productsMap.get(productName);
                const key = `${assetType}_${productName}`;
                productListForAssetType.push({ 
                  productName, 
                  id: key, 
                  assignInfo, 
                  product_id: assignInfo.product_id 
                });
              });
            }
            if (productListForAssetType.length > 0) {
              newGroupedProducts.set(assetType, productListForAssetType);
            }
          }
        }
      }

      // 各ポートフォリオの構成比を計算
      const originalRatios = new Map(); // 100%調整前の真の初期値
      const adjustedRatios = new Map(); // 100%調整後の値
      
      portfolioNamesList.forEach(portfolioName => {
        const portfolio = portfolios.get(portfolioName);
        if (!portfolio || !portfolio.assetProductAssigns) return;

        const portfolioRatiosMap = new Map();
        const portfolioBalance = parseFloat(initialBalances.get(portfolioName)) * PRODUCT_ASSIGN_UNIT;

        // 構成比を計算（100%調整前の真の初期値）
        for (const [assetType, productsMap] of portfolio.assetProductAssigns.entries()) {
          if (productsMap instanceof Map) {
            for (const [productName, assignInfo] of productsMap.entries()) {
              const key = `${assetType}_${productName}`;
              const productAmount = (assignInfo.assign || 0) * PRODUCT_ASSIGN_UNIT;
              
              if (portfolioBalance > 0) {
                const ratio = ((productAmount / portfolioBalance) * 100).toFixed(1);
                console.log(`V3Dialog - ${portfolioName} ${key}: productAmount=${productAmount}, ratio=${ratio}`);
                portfolioRatiosMap.set(key, ratio);
              } else {
                console.log(`V3Dialog - ${portfolioName} ${key}: portfolioBalance is 0, setting ratio to 0.0`);
                portfolioRatiosMap.set(key, "0.0");
              }
            }
          }
        }

        // 100%調整前の真の初期値を保存
        originalRatios.set(portfolioName, new Map(portfolioRatiosMap));

        // 100%調整後の値を計算
        const adjustedRatiosMap = new Map(portfolioRatiosMap);
        adjustRatiosTo100Percent(adjustedRatiosMap);
        adjustedRatios.set(portfolioName, adjustedRatiosMap);

        // 初期表示用：現状ポートは100%調整前、それ以外は100%調整後
        const isCurrentPort = isCurrentPortfolio(portfolioName);
        if (isCurrentPort) {
          initialRatios.set(portfolioName, new Map(portfolioRatiosMap)); // 100%調整前
        } else {
          initialRatios.set(portfolioName, adjustedRatiosMap); // 100%調整後
        }
        
        console.log(`V3Dialog - ${portfolioName} originalRatios:`, portfolioRatiosMap);
        console.log(`V3Dialog - ${portfolioName} adjustedRatios:`, adjustedRatiosMap);
      });

      setGroupedProducts(newGroupedProducts);
      setPortfolioRatios(initialRatios);
      setOriginalPortfolioRatios(originalRatios); // 100%調整前の真の初期値を保存
      setAdjustedPortfolioRatios(adjustedRatios); // 100%調整後の値を保存
    } else {
      setPortfolioRatios(new Map());
      setGroupedProducts(new Map());
      setPortfolioNames([]);
      setPortfolioBalances(new Map());
    }
  }, [show, portfolios, amData]);

  // ダイアログの幅を動的に計算
  useEffect(() => {
    if (portfolioNames.length > 0) {
      // 基本的な幅の計算
      const productListWidth = 385; // ProductListHeaderの幅
      const portfolioColumnWidth = 130; // PortfolioHeaderの幅 + margin
      const contentWidth = productListWidth + (portfolioNames.length * portfolioColumnWidth);
      const paddingAndMargin = 200; // パディング、マージン、スクロールバーなどの余白
      
      // 計算された幅 + 100px
      let calculatedWidth = contentWidth + paddingAndMargin + 100;
      
      // ブラウザ画面幅の2/3を上限とする
      const maxWidth = Math.floor(window.innerWidth * 2 / 3);
      
      // 最小幅は800px、最大幅はブラウザ幅の2/3
      const finalWidth = Math.max(800, Math.min(calculatedWidth, maxWidth));
      
      setDialogWidth(finalWidth);
    }
  }, [portfolioNames]);

  // ポートフォリオごとの対象チェックボックスの変更を監視
  useEffect(() => {
    if (portfolioNames.length === 0 || originalPortfolioRatios.size === 0 || adjustedPortfolioRatios.size === 0) return;

    setPortfolioRatios(prevRatios => {
      const newRatios = new Map(prevRatios);
      
      portfolioNames.forEach(portfolioName => {
        // ユーザーが手動で変更したポートフォリオは調整処理をスキップ
        if (userModifiedPortfolios.has(portfolioName)) {
          return; // 現在の値を維持（何もしない）
        }
        
        const targetEnabled = portfolioTargetEnabled.get(portfolioName) || false;
        const originalRatiosMap = originalPortfolioRatios.get(portfolioName);
        const adjustedRatiosMap = adjustedPortfolioRatios.get(portfolioName);
        
        if (!originalRatiosMap || !adjustedRatiosMap) return;
        
        if (targetEnabled) {
          // チェックが入った場合：100%調整後の値を適用
          newRatios.set(portfolioName, new Map(adjustedRatiosMap));
        } else {
          // チェックが外れた場合：100%調整後の値から変更されていない場合のみ初期値に戻す
          const currentRatiosMap = newRatios.get(portfolioName);
          if (currentRatiosMap && isUnchangedFromAdjusted(currentRatiosMap, adjustedRatiosMap)) {
            // 100%調整後の値から変更されていない場合のみ、100%調整前の初期値に戻す
            newRatios.set(portfolioName, new Map(originalRatiosMap));
          }
          // ユーザーが手動で変更している場合は、現在の値を維持（何もしない）
        }
      });
      
      return newRatios;
    });
  }, [portfolioTargetEnabled, portfolioNames, originalPortfolioRatios, adjustedPortfolioRatios, userModifiedPortfolios]);

  // 100%調整後の値から変更がないかチェックする関数
  const isUnchangedFromAdjusted = (currentRatiosMap, adjustedRatiosMap) => {
    // 全ての商品キーを取得（currentとadjustedの両方から）
    const allKeys = new Set([
      ...Array.from(currentRatiosMap.keys()),
      ...Array.from(adjustedRatiosMap.keys())
    ]);
    
    // 各商品について、現在の値と100%調整後の値を比較
    for (const key of allKeys) {
      const currentValue = parseFloat(currentRatiosMap.get(key) || 0);
      const adjustedValue = parseFloat(adjustedRatiosMap.get(key) || 0);
      
      if (Math.abs(currentValue - adjustedValue) > 1e-9) {
        return false; // 一つでも違いがあれば「変更あり」
      }
    }
    return true; // 全ての商品で値が同じなら「変更なし」
  };

  const handleRatioChange = (portfolioName, productIdKey, value) => {
    // 小数点第一位まで制限
    const regex = /^\d*\.?\d{0,1}$/;
    if (value === "" || regex.test(value)) {
      const numericValue = parseFloat(value);
      if (value === "" || (numericValue >= 0 && numericValue <= 100)) {
        // ユーザーが手動で変更したポートフォリオを記録
        setUserModifiedPortfolios(prev => {
          const newSet = new Set(prev);
          newSet.add(portfolioName);
          return newSet;
        });
        
        setPortfolioRatios(prevRatios => {
          const newRatios = new Map(prevRatios);
          const portfolioRatiosMap = new Map(newRatios.get(portfolioName) || new Map());
          portfolioRatiosMap.set(productIdKey, value);
          newRatios.set(portfolioName, portfolioRatiosMap);
          return newRatios;
        });
      }
    }
  };

  const handleBalanceChange = (portfolioName, value) => {
    // 整数のみ許可（小数点入力を制限）
    if (/^\d*$/.test(value) || value === "") {
      setPortfolioBalances(prevBalances => {
        const newBalances = new Map(prevBalances);
        newBalances.set(portfolioName, value);
        return newBalances;
      });
    }
  };

  const calculatePortfolioTotal = (portfolioName) => {
    const portfolioRatiosMap = portfolioRatios.get(portfolioName);
    if (!portfolioRatiosMap) return 0;
    
    // BigNumberを使用して合計を計算
    const total = Array.from(portfolioRatiosMap.values()).reduce(
      (sum, ratio) => sum.plus(new BigNumber(ratio || 0)),
      new BigNumber(0)
    );
    
    return total.toNumber();
  };

  const handleSave = () => {
    if (onSubmit) {
      onSubmit({ 
        portfolioBalances, 
        portfolioRatios, 
        portfolioTargetEnabled
      });
    }
    onClose();
  };

  const isSaveDisabled = () => {
    // 対象チェックボックスがONのポートフォリオをチェック
    for (const portfolioName of portfolioNames) {
      const targetEnabled = portfolioTargetEnabled.get(portfolioName) || false;
      
      if (targetEnabled) {
        const total = calculatePortfolioTotal(portfolioName);
        const balance = parseFloat(portfolioBalances.get(portfolioName) || 0);
        
        // 構成比が0より大きい場合は残高も必要
        if (total > 0) {
          if (balance <= 0) {
            return true; // 構成比があるのに残高が0の場合は保存不可
          }
          if (Math.abs(total - 100) > 1e-9) {
            return true; // 構成比が100%でない場合は保存不可
          }
        }
        // 構成比が0の場合は残高が0でも保存可能（何もしない）ura
      }
    }

    return false;
  };

  return (
    <>
      <CSSTransition
        in={show}
        timeout={300}
        classNames="ratio-editor-v3-modal-sidebar"
        unmountOnExit
      >
        <FormDiv onKeyDown={handleKeyDown} dialogWidth={dialogWidth}>
          <FormHeader>
            <span>構成比入力</span>
            <div style={{display: "flex", alignItems: "center"}}>
              <button
                onClick={onClose}
                style={{
                  border: "none",
                  backgroundPosition: "center",
                  width: 20,
                  height: 20,
                  backgroundImage: "url(/img/X.svg)",
                  backgroundColor: "transparent",
                  marginRight: 20,
                  cursor: "pointer",
                }}
              />
            </div>
          </FormHeader>
          <FormContent>
            <TableContainer>
              <ScrollableTableWrapper>
                <ScrollableTableContent>
                  <TableHeader>
                  <Header>
                    <PortfolioName>&nbsp;</PortfolioName>
                    <CheckBoxLabel >更新対象：</CheckBoxLabel>
                  </Header>
                            
                    {portfolioNames.map(portfolioName => {
                      const targetEnabled = portfolioTargetEnabled.get(portfolioName) || false;
                      
                      return (
                        <PortfolioHeader key={portfolioName}>
                          <PortfolioName>{portfolioName}</PortfolioName>
                          <PortfolioCheckboxContainer>
                            <input
                              type="checkbox"
                              id={`target-${portfolioName}`}
                              checked={targetEnabled}
                              onChange={(e) => {
                                setPortfolioTargetEnabled(prev => {
                                  const newMap = new Map(prev);
                                  newMap.set(portfolioName, e.target.checked);
                                  return newMap;
                                });
                              }}
                            />
                            {/* <PortfolioCheckboxLabel htmlFor={`target-${portfolioName}`}>
                              対象
                            </PortfolioCheckboxLabel> */}
                          </PortfolioCheckboxContainer>
                        </PortfolioHeader>
                      );
                    })}
                  </TableHeader>

                  {/* 残高入力行 */}
                  {(() => {
                    // 全商品数を計算（残高入力のtabIndex計算で使用）
                    const totalProducts = Array.from(groupedProducts.values()).reduce((sum, productList) => sum + productList.length, 0);
                    
                    return (
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', marginLeft: '125px' }}>
                        <BalanceLabel>残高（単位 100万円）：</BalanceLabel>
                        {portfolioNames.map((portfolioName, portfolioIndex) => {
                          const targetEnabled = portfolioTargetEnabled.get(portfolioName) || false;
                          const isEditable = targetEnabled;
                          const balance = portfolioBalances.get(portfolioName) || "";
                          const total = calculatePortfolioTotal(portfolioName);
                          const balanceValue = parseFloat(balance || 0);
                          
                          // 構成比が0より大きいのに残高が0の場合はエラー
                          const hasError = isEditable && total > 0 && balanceValue <= 0;
                          
                          let className = "";
                          if (!isEditable) {
                            className = "disabled";
                          } else if (hasError) {
                            className = "error";
                          }

                          return (
                            <BalanceInputWrapper 
                              key={`balance-${portfolioName}`}
                              className={className}
                            >
                              <BalanceInput
                                type="text"
                                value={balance}
                                onChange={(e) => handleBalanceChange(portfolioName, e.target.value)}
                                placeholder="0"
                                disabled={!isEditable}
                                tabIndex={calculateBalanceTabIndex(portfolioIndex, totalProducts)}
                              />
                            </BalanceInputWrapper>
                          );
                        })}
                      </div>
                    );
                  })()}

                  {groupedProducts.size > 0 ? (
                    (() => {
                      // 全商品数を計算
                      const totalProducts = Array.from(groupedProducts.values()).reduce((sum, productList) => sum + productList.length, 0);
                      
                      // 全商品のインデックスを計算するために、商品リストを平坦化
                      let globalProductIndex = 0;
                      return Array.from(groupedProducts.entries()).map(([assetType, productList]) => (
                        <AssetGroupDiv key={assetType} style={{ borderLeftColor: assetColors[assetType] }}>
                          {productList.map(({ productName, id }, productIndex) => {
                            const currentGlobalIndex = globalProductIndex++;
                            return (
                              <ProductRow key={id} className={assetTypeClassNameMap[assetType]}>
                                <AssetTypeDisplayContainer>
                                  {productIndex === 0 && (
                                    <AssetTypeNameSpan>
                                      {assetNames && assetNames[assetType] ? assetNames[assetType] : assetType}
                                    </AssetTypeNameSpan>
                                  )}
                                </AssetTypeDisplayContainer>
                                <ProductNameSpan title={`${assetNames && assetNames[assetType] ? assetNames[assetType] : assetType} - ${productName}`}>
                                  {productName}
                                </ProductNameSpan>
                                
                                {portfolioNames.map((portfolioName, portfolioIndex) => {
                                  const targetEnabled = portfolioTargetEnabled.get(portfolioName) || false;
                                  const isEditable = targetEnabled;
                                  const portfolioRatiosMap = portfolioRatios.get(portfolioName);
                                  const ratio = portfolioRatiosMap ? portfolioRatiosMap.get(id) || "" : "";

                                  return (
                                    <RatioInputWrapper 
                                      key={`${portfolioName}-${id}`}
                                      className={!isEditable ? "disabled" : ""}
                                    >
                                      <RatioInput
                                        type="number"
                                        value={ratio}
                                        onChange={(e) => handleRatioChange(portfolioName, id, e.target.value)}
                                        placeholder="0.0"
                                        disabled={!isEditable}
                                        min="0"
                                        max="100"
                                        step="0.1"
                                        tabIndex={calculateTabIndex(currentGlobalIndex, portfolioIndex, totalProducts)}
                                      />
                                      <PercentSpan>%</PercentSpan>
                                    </RatioInputWrapper>
                                  );
                                })}
                              </ProductRow>
                            );
                          })}
                        </AssetGroupDiv>
                      ));
                    })()
                  ) : (
                    <p>対象ポートフォリオに商品が割り当てられていません。</p>
                  )}

                  <TotalRow>
                    <TotalLabel>構成比合計:</TotalLabel>
                    {portfolioNames.map(portfolioName => {
                      const total = calculatePortfolioTotal(portfolioName);
                      const targetEnabled = portfolioTargetEnabled.get(portfolioName) || false;
                      const isEditable = targetEnabled;
                      const shouldValidate = targetEnabled;
                      const isValid = !shouldValidate || Math.abs(total - 100) < 1e-9;

                      return (
                        <TotalValue 
                          key={portfolioName} 
                          isValid={isValid}
                          isDisabled={!isEditable}
                        >
                          {total.toFixed(1)}%
                        </TotalValue>
                      );
                    })}
                  </TotalRow>
                </ScrollableTableContent>
              </ScrollableTableWrapper>
            </TableContainer>
          </FormContent>
          <FormFooter>
            <CancelButton onClick={onClose}>キャンセル</CancelButton>
            <SaveButton 
              onClick={handleSave} 
              disabled={isSaveDisabled()} 
              className={isSaveDisabled() ? "inactive" : ""}
            >
              保存
            </SaveButton>
          </FormFooter>
        </FormDiv>
      </CSSTransition>
      {show && <AllFadeFrame onClick={onClose} />}
    </>
  );
};

export default PortfolioRatioEditDialogV3;
